import type { SortFieldType } from '@repo/ui';

/**
 * Data type for every sortable field in the app, keyed by field name (VERA-480).
 *
 * This is the "load the filter/sort UI from the field's data type instead of hardcoding
 * it" registry. `SortField` reads it as its DEFAULT, so a surface gets correct direction
 * labels just by sorting on a known field — no per-call-site wiring, and no chance of one
 * drawer being fixed while three others keep saying "A - Z" on a timestamp.
 *
 * Adding a sortable field? Add its type here. A field that's missing degrades to text
 * labels rather than throwing, matching the platform's forgiving default — but a DATE
 * left out of this map is exactly the bug this registry exists to prevent, so check.
 */
export const SORT_FIELD_TYPES: Record<string, SortFieldType> = {
  // Certificates list
  name: 'string',
  status: 'string',
  last_activity: 'dateTime',
  last_scan: 'dateTime',
  sell_price: 'number',

  // Scans + provenance
  owner_name: 'string',
  date: 'dateTime',
  location: 'string',
};
